import { render, staticRenderFns } from "./financeiro-tabela-amb.vue?vue&type=template&id=4adc87de&scoped=true"
import script from "./financeiro-tabela-amb.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-amb.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-amb.vue?vue&type=style&index=0&id=4adc87de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc87de",
  null
  
)

export default component.exports